import { Input } from "./ui/input"
import { Label } from "./ui/label"
import { DatePicker } from './ui/datepicker'

interface CurrentBalanceProps {
  balance: number;
  onBalanceChange: (balance: number) => void;
  date: Date;
  onDateChange: (date: Date) => void;
}

function CurrentBalance({ balance, onBalanceChange, date, onDateChange }: CurrentBalanceProps) {
  return (
    <div className="flex gap-4">
      <div className="space-y-1 flex-1">
        <Label htmlFor="balance">Balance</Label>
        <div className="relative">
          <span className="absolute left-3 top-2.5">$</span>
          <Input
            id="balance"
            type="number"
            value={balance == 0 ? '' : balance}
            onChange={(e) => onBalanceChange(Number(e.target.value))}
            className="pl-6"
          />
        </div>
      </div>
      <div className="space-y-1 flex-1">
        <Label>Date</Label>
        <DatePicker
          date={date}
          onChange={(date) => date && onDateChange(date)}
        />
      </div>
    </div>
  );
}

export default CurrentBalance; 